
import { ModelBase } from 'store/model-base';

export class CmsQuickpayErrors extends ModelBase {
    public static storeName: string = 'cmsQuickpayErrors';

    public error: CmsQuickpayError[];
}
